




import Vue from "vue";
import i18n from "../../i18n";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { mapState } from "vuex";
import { ToastPlugin } from "bootstrap-vue";
import { RootMutationTypes, RootState } from "../../store";
import { ToastMessage } from "../../models/toast-message.model";

Vue.use(ToastPlugin);

const SHOW_TOAST_TIMEOUT = 3000;
const TOAST_ARRAY_DELAY = 500;

@Component({
  name: "Toast",
  computed: {
    ...mapState<RootState>({
      toastMessages: (state: RootState) => state.toastMessages
    })
  }
})
export default class Toast extends Vue {
  @Watch("toastMessages")
  makeToast(toastMessages: ToastMessage | ToastMessage[]) {
    if (Array.isArray(toastMessages)) {
      toastMessages.forEach((toastMessage, index) => setTimeout(() => this.showToast(toastMessage), index * TOAST_ARRAY_DELAY));
    } else {
      this.showToast(toastMessages);
    }
  }

  showToast(toastMessage: ToastMessage, delay = SHOW_TOAST_TIMEOUT) {
    const { title, content, variant } = toastMessage;

    this.$bvToast.toast(content, {
      title,
      variant,
      solid: true,
      appendToast: true,
      autoHideDelay: delay,
      toaster: "b-toaster-bottom-right"
    });
  }
}
